import React, { useState, useContext } from 'react';
import { Table, ConfigProvider } from 'antd';
import { TableStyled } from './DataTableStyled';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import NoData from '@/components/no_data_show/NoData';
import { LoadingOutlined } from '@ant-design/icons';
const DataTable = (props) => {
  const {
    style,
    columns,
    dataSource = [],
    rowSelection,
    pagination,
    loading,
    className,
    scroll,
    onRowClick,
    size,
    expandable,
    title,
    footer,
    rowKey,
  } = props;
  const [pageSize, setPageSize] = useState(
    props.pagination ? props.pagination.pageSize : 10,
  );
  const paginationProps = pagination
    ? {
        position: 'bottom',
        // size: pagination.size ? pagination.size : 'normal',
        showSizeChanger: true,
        showQuickJumper: false,

        // pageSize如果父组件传来，则父组件要设置setState pageSize，如父组件不传，则无需设置
        pageSize: pageSize ? pageSize : 10,
        current: pagination.page ? pagination.page : 1,
        pageSizeOptions: pagination.pageSizeOptions
          ? pagination.pageSizeOptions
          : ['5', '10', '25', '50', '100'],
        total: pagination.total ? pagination.total : 0,
        onShowSizeChange: (a, b) => changePageSize(a, b),
      }
    : false;

  // 回调函数,每页显示多少条
  let changePageSize = (a, b) => {
    setPageSize(b);
    props.changePageSize(b);
  };

  // table 页数和每页数量改变时都会调用
  let handleChange = (e) => {
    props.changePage(e);
  };

  // 点击行
  let handleRowClick = (e) => {
    props.onRowClick(e);
  };
  const customizeRenderEmpty = () => (
    //这里面就是我们自己定义的空状态
    <NoData loading={loading} />
  );
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const btn =
    themeContext &&
    themeContext[brandContext] &&
    themeContext[brandContext].btn;
  return (
    <React.Fragment>
      <TableStyled theme={themeContext} brand={brandContext}>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <Table
            className={className}
            style={style}
            rowSelection={
              rowSelection === false
                ? false
                : {
                    ...rowSelection,
                    columnWidth:
                      rowSelection && rowSelection.columnWidth
                        ? rowSelection && rowSelection.columnWidth
                        : '5rem',
                  }
            }
            rowClassName={(record, index) => {
              let classNameLightDartRow = 'zebra-highlight';
              if (index % 2 !== 1) {
                classNameLightDartRow = 'dark-row';
              }
              return classNameLightDartRow;
            }}
            size={size ? size : 'normal'}
            loading={{
              indicator: (
                // <Icon
                //   type="loading"
                //   style={{ , color: 'red' }}
                //   spin
                // />
                <LoadingOutlined
                  style={{ fontSize: '2rem', color: btn && btn.bgColor }}
                />
              ),
              spinning: Boolean(loading),
              delay: 500,
            }}
            rowKey={(record) => (rowKey ? record.id : record)} //index不具有唯一性
            scroll={scroll}
            columns={columns}
            dataSource={dataSource}
            pagination={paginationProps}
            onChange={handleChange}
            onRow={(record) => {
              return {
                onClick: () => {
                  return onRowClick ? handleRowClick(record) : null;
                }, // 点击行
                // onDoubleClick: () => { },
                // onContextMenu: () => { },
                // onMouseEnter: () => { }, // 鼠标移入行
                // onMouseLeave: () => { },
              };
            }}
            expandable={expandable}
            title={title}
            footer={footer}
          />
        </ConfigProvider>
      </TableStyled>
    </React.Fragment>
  );
};
export default DataTable;
